var map = {
	"./a4-1-child.ejs": "e1e8",
	"./a4-1-home.ejs": "0a7c",
	"./a4-1.ejs": "e52a",
	"./a4-2-blog.ejs": "d883",
	"./a4-2.ejs": "0962",
	"./a4-3.ejs": "eaa6",
	"./a4-blog.ejs": "d505",
	"./a4.ejs": "4d6b",
	"./a5-1.ejs": "de4d",
	"./a5-2.ejs": "7ee7",
	"./a5-3.ejs": "1ab3",
	"./a5-4.ejs": "51c9",
	"./a5-5-child.ejs": "a0cf",
	"./a5-5.ejs": "610b",
	"./a5-6.ejs": "e8af",
	"./a5-blog.ejs": "9e25",
	"./block.ejs": "7546",
	"./decoration.ejs": "f169",
	"./image-new.ejs": "bd07",
	"./label-a4-1-child-baby.ejs": "1c41",
	"./label-a4-1-child.ejs": "2475",
	"./label-a4-1.ejs": "fe21",
	"./label-a4-3-baby.ejs": "6b33",
	"./label-a4-3.ejs": "35dc",
	"./label-a4.ejs": "0c4b",
	"./label-a5-1.ejs": "609f",
	"./label-a5-2.ejs": "5806",
	"./label-a5-3.ejs": "f2f1",
	"./label-a5-4.ejs": "cbfb",
	"./label-a5-5.ejs": "4204",
	"./text-blogbook.ejs": "30ed",
	"./text-html.ejs": "f8a6",
	"./text-old.ejs": "92c3",
	"./text-svg.ejs": "9eb1",
	"./utils.ejs": "bbdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a199";